import React, { useState } from 'react';
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "../../../components/form/Button";
import { AutoCompleteItems } from "../../../components/form/AutoCompleteItems";
import { InspectionResult } from "../enum";
import { styles } from "../index";
import Input from "../../../components/form/Input";

const InspectionForwardingDialog = ({ onCancel, onForward, administrativeAutoritiesOptions, forwardTo }) => {
  const [selectedForwardTo, setSelectedForwardTo] = useState(forwardTo);
  const [note, setNote] = useState('');

  return (
      <Dialog open={true}
              onClose={onCancel}
              onKeyDown={(e) => e.stopPropagation()}
              onClick={(e) => e.stopPropagation()}
              maxWidth="sm"
              fullWidth
              className="cro__inspectionForwardingDialog">
        <DialogTitle>
          Kontrola s problémy
        </DialogTitle>
        <DialogContent>
          <AutoCompleteItems label="Předání přestupkovému orgánu"
                             options={administrativeAutoritiesOptions}
                             defaultValue={selectedForwardTo}
                             onChanged={(val) => setSelectedForwardTo(val)}/>

          <label>Poznámka</label>
          <Input multiline={true}
                 rows={4}
                 maxLength={1000}
                 input={{
                   value: note,
                   onChange: (e) => setNote(e)
                 }}
          />

        </DialogContent>
        <DialogActions style={{gap: 12, padding: '8px 24px 16px'}}>
          <Button
              type="button"
              style={styles.buttons}
              label="Zpět"
              onClick={onCancel}
          />
          <Button
              type="button"
              style={styles.buttons}
              label="Uložit"
              disabled={!selectedForwardTo}
              onClick={() => onForward(InspectionResult.PROBLEM, selectedForwardTo, note)}
          />
        </DialogActions>
      </Dialog>
  );
}

export default InspectionForwardingDialog;